{
  "name": "kokos-ui",
  "version": "2.49.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:local": "ng serve --configuration=local",
    "build": "ng build --configuration=production",
    "build:ci": "ng build --configuration=production",
    "watch": "ng build --watch --configuration=local",
    "test": "ng test -c karma --watch=false --progress=false && ng test -c vitest --watch=false",
    "test:karma": "ng test -c karma --watch=false --progress=false",
    "test:vitest": "ng test -c vitest --watch=false",
    "test:ci": "ng test -c karma --watch=false --coverage && ng test -c vitest --watch=false",
    "test:karma:ci": "ng test -c karma --watch=false --coverage",
    "test:vitest:ci": "ng test -c vitest --watch=false --coverage",
    "sonar": "sonar-scanner",
    "test-ui": "cross-env TEST_MODE=ui ng test",
    "local": "run-p stubbed-api servelocal",
    "stubbed-api": "node mock/rest-api/server.js",
    "servelocal": "ng serve --configuration=local"
  },
  "private": true,
  "dependencies": {
    "@angular/common": "22.2.1",
    "@angular/compiler": "22.2.1",
    "@angular/core": "22.2.1",
    "@angular/forms": "22.2.1",
    "@angular/platform-browser": "22.2.1",
    "@angular/router": "22.2.1",
    "@design/bapf-pattern-library": "3.11.2",
    "@header-footer/bahf-header-footer-fallback": "3.19.0",
    "@oiambk/oiam-oauth-types": "2.0.2",
    "@oiambk/oiam-oauth-wc": "2.1.13",
    "angular-i18next": "21.0.0",
    "bootstrap": "5.3.8",
    "dayjs": "1.11.23",
    "dompurify": "3.4.16",
    "graphemer": "1.4.0",
    "i18next": "26.4.2",
    "i18next-browser-languagedetector": "8.2.1",
    "i18next-http-backend": "4.0.2",
    "linkify-html": "4.3.3",
    "linkifyjs": "4.3.3",
    "ngx-device-detector": "12.0.0",
    "pdfkit": "0.20.2",
    "rxjs": "7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "0.16.3"
  },
  "devDependencies": {
    "@angular/build": "22.2.1",
    "@angular/cli": "22.2.1",
    "@angular/compiler-cli": "22.2.1",
    "@types/bootstrap": "5.2.11",
    "@types/jasmine": "7.0.0",
    "@types/pdfkit": "0.17.6",
    "@vitest/browser-playwright": "5.0.2",
    "@vitest/coverage-v8": "5.0.2",
    "cross-env": "10.1.0",
    "express": "5.2.1",
    "jasmine-core": "7.0.2",
    "jsdom": "30.1.1",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.3.0",
    "karma-spec-reporter": "0.0.37",
    "sonar-scanner": "3.1.0",
    "typescript": "6.0.3",
    "vitest": "5.0.2"
  },
  "overrides": {
    "@angular/ssr": "~22.2.1"
  },
  "allowScripts": {
      "@parcel/watcher@2.6.0": true,
      "core-js@3.47.0": true,
      "esbuild@0.28.2": true,
      "esbuild@0.27.7": true,
      "lmdb@3.5.6": true,
      "msgpackr-extract@3.0.4": true,
      "sonar-scanner@3.1.0": true
    }
}
